(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-accordion"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const popupOverlay = document.getElementById('popup-overlay');
  const popupImg = document.getElementById('popup-img');
  const popupTitle = document.getElementById('popup-title');
  const popupDesc = document.getElementById('popup-desc');
  const closeBtn = document.getElementById('popup-close');

  document.querySelectorAll('.image-accordion-image').forEach(img => {
    img.addEventListener('click', () => {
      popupImg.src = img.dataset.image;
      popupTitle.innerText = img.dataset.title;
      popupDesc.innerText = img.dataset.description;
      popupOverlay.style.display = 'flex';
    });
  });

  closeBtn.addEventListener('click', () => {
    popupOverlay.style.display = 'none';
  });

  popupOverlay.addEventListener('click', (e) => {
    if (e.target === popupOverlay) {
      popupOverlay.style.display = 'none';
    }
  });
});


  } catch(e) { console.error(e); }
})();
})();
